import { zodResolver } from '@hookform/resolvers/zod';
import { SetStateAction } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { ErrorResponse } from '@shared/api';
import { ToastService } from '@shared/ui';

import { useHeaderSheetOpenStore } from '@shared/store';

import { TFeedbackRequest } from '../../api';
import { FeedbackValidation } from '../schema';
import { useAddFeedBack } from '../../api';

type TFeedback = {
  setIsOpen: (value: SetStateAction<boolean>) => void;
  setIsWidgetOpen: (value: SetStateAction<boolean>) => void;
};
export const useFeedback = ({ setIsOpen, setIsWidgetOpen }: TFeedback) => {
  const form = useForm<z.infer<typeof FeedbackValidation>>({
    resolver: zodResolver(FeedbackValidation),
    defaultValues: {
      rank: 3,
      description: '',
    },
  });
  const feedbackMutation = useAddFeedBack();

  const handleFormSubmit = (data: TFeedbackRequest) => {
    feedbackMutation.mutate(data, {
      onError: (error: ErrorResponse) => {
        const errorMessage = error ? error.formatMessage() : 'خطا در ارسال بازخورد';
        ToastService.error(errorMessage);
      },
      onSuccess: () => {
        ToastService.success('بازخورد شما با موفقیت ثبت شد');
        setIsOpen(false);
        setIsWidgetOpen(false);
        if (IsSheetOpen) setIsSheetOpen(false);
      },
    });
  };
  const watchedRank = form.watch('rank');

  const handleSubmit = (values: z.infer<typeof FeedbackValidation>) => {
    const feedbackData = {
      rank: values.rank!,
      description: values.description?.trim() || '',
    };

    handleFormSubmit(feedbackData);
  };

  const handleRankSelect = (rank: number) => {
    form.setValue('rank', rank);
    form.clearErrors('rank');
  };
  const rankButtons = [
    { rank: 5, emoji: '😍' },
    { rank: 4, emoji: '😃' },
    { rank: 3, emoji: '😊' },
    { rank: 2, emoji: '😕' },
    { rank: 1, emoji: '😡' },
  ];
  const setIsSheetOpen = useHeaderSheetOpenStore((state) => state.setter);
  const IsSheetOpen = useHeaderSheetOpenStore((state) => state.data);
  const loading = feedbackMutation.isPending;

  return { watchedRank, handleRankSelect, handleSubmit, rankButtons, form, isLoading: loading };
};
